import { Divider } from "@chakra-ui/react"


export const SectionBreak = ({ field }: any) => {

    return (
        <Divider />
    )
}